import classnames from "classnames";
import React from "react";
import { Collapse as CollapseComponent } from "src/components";
import theme from "src/theme";
import styled from "styled-components";

import { Slice } from "../components";
import { ISliceCollapse } from "../types";

const StyledCollapse = styled(CollapseComponent)`
  .toggle-collapse {
    border-color: ${theme.colors.black};

    i {
      color: ${theme.colors.black};
    }

    &:hover {
      background-color: ${theme.colors.black};

      i {
        color: ${theme.colors.white};
      }
    }
  }
`;

export const Collapse = ({
  slice_type,
  primary,
  items,
}: ISliceCollapse): JSX.Element | null => {
  const { class_name: className } = primary;

  return (
    <Slice className={classnames("slice-collapse", className)} noGutter>
      <StyledCollapse data={primary} />
    </Slice>
  );
};
